import React, {Component} from 'react';
import SideBar from './sidebar/SideBar';
import Footer from './components/Footer';
import Nav from './Header/Nav';
import javas from '../assets/images/java.jpg';
import java from '../assets/images/java.png';
import vscode from '../assets/images/vscode.jpg';
import DevelopRequest from './components/DevelopRequest';
import Subscribe from './components/Subscribe';

class Java extends Component{
    render(){
        return(
            <div id="App">
            <SideBar />
                <Nav />
            <header className="showcase" style={{height:'80vh', marginTop:'5vh', backgroundImage: `url(${vscode})`}}>
			<div className="showcase-content">
                <div></div>
                <div>
				<h1>Be in <span className="alt-col" style={{color:'rgba(226, 155, 24, 0.945)'}}> Demand.</span></h1>
                <p>"I always advise people – Don’t wait! Do something when you are young, when you have nothing to lose, and keep that in mind."</p>
                <p>
                &mdash; Steve Jobs.
                </p>
                </div>
			</div>
		</header>
        <div className="about">
            <div style={{backgroundImage: `url(${javas})`, backgroundClip:'border-box', backgroundPosition:'center', backgroundSize:'cover'}}></div>

            <div>
            <h3 className="path">Java Programing</h3>
            <img src={java} alt="java training in kubwa abuja" />
            <p> 
              From data types to variable declaration, to inheritance, to encapsulation, this course will take you from basic to advanced level of
              Java programming.
            </p>
            <p> 
             Become proficient in Java programing
            </p>

            <h3>courses</h3>
            <p>
                Java using Netbeans IDE
            </p>

            <h3>call anytime</h3>
            <p>07063509602, 07084894979</p>
            <p>info@codeflarelimited.com</p>

            <h3>visit us</h3>
            <p>Suite C3-19 Central Market Plaza, Beside Sledge Resort, Off Byazhin Roundabout, Kubwa, Abuja.</p>
            </div>
        </div>
        <DevelopRequest />
        <Subscribe />
        <Footer />
            </div>
        )
    }
}

export default Java;